import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

import { addressFormFields } from './addressFieldsForm';

const formFields = [
  {
    name: 'agentName',
    label: 'Agent Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'agentNmlsId',
    label: 'Agent License Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'agentStateLicenseId',
    label: 'Agent State License ID',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'office',
    label: 'Agent Office',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'companyNmlsId',
    label: 'Company License Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'companyStateLicenseId',
    label: 'Company State License ID',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'email',
    label: 'Email',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'phone',
    label: 'Phone',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'fax',
    label: 'Fax',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  ...addressFormFields,
];

export const agentForm = {
  name: FormNames.AGENT,
  label: 'Selling Agent',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
